/* eslint-disable */
import React, { useState, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { AppDispatch, RootState } from '../../store/store';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { openDialogMeteringDeviceAdditional } from '../../store/reducers/openDialogMeteringDeviceAdditionalSlice';
import { Box, Typography, Button, Divider, Stack } from '@mui/material';
import { DialogMeteringDeviceAdditionalRequest } from './DialogMeteringDeviceAdditionalRequest';
import DialogMeteringDeviceAdditionalJournal from './DialogMeteringDeviceAdditionalJournal';

const useStyles = makeStyles({
 dialog: { height: '100%' },
 dialogContainer: {
  '& .MuiDialog-container': {
   justifyItems: 'center',
   display: 'flex',
   width: '100%',
   height: '1000px',
   overflow: 'hidden',
  },
  '& .MuiTypography-root': { display: 'flex', alignItems: 'center' },
  '& .MuiDialogContent-root': {
   overflow: 'hidden',
   padding: '0 !important',
   margin: '0 !important',
  },
  '& .MuiDialog-paper': { height: '850px' },
 },
 dialogTitle: {
  height: '40px',
  border: '1px solid #cacaca',
  color: 'black !important',
  padding: '0 24px !important',
 },
});

function PaperComponent(props: PaperProps) {
 return (
  <Draggable
   handle="#draggable-dialog-title"
   cancel={'[class*="MuiDialogContent-root"], button, svg'}
  >
   <Paper {...props} />
  </Draggable>
 );
}

const DialogMeteringDeviceAdditional = (props: any) => {
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();
 const currentDateTime = '05.11.2026, 09:30:08';

 const [isRequestOpen, setIsRequestOpen] = useState<boolean>(false);
 const [isJournalOpen, setIsJournalOpen] = useState<boolean>(false);

 const [data] = useState({
  address:
   'г. Москва, ул. Ленина, д. 10, корпус 2, строение 1, кв. 45, индекс 101000, Российская Федерация',
  buildingType:
   'Многоквартирный жилой дом повышенной этажности с подземным паркингом',
  roomType: 'Жилое изолированное помещение (приватизированная квартира)',
  deliveryPointId: 'E-1293847192-XYZ-999-MOCKOW-CENTER-STATUS-ACTIVE',
  relayStatus: 'Включено (Замкнуто / Сигнал стабильный)',
  meterType: 'Меркурий 230 ART-02 CN threephase встроенный',
  commissioningDate: '12.04.2021',
  installationPlace:
   'Этажный распределительный щит, 3 этаж, секция Б, место №4',
  serialNumber: '29384719',
  unit: 'кВт·ч',
  accuracyClass: '1.0',
  capacity: '6',
  phaseCount: '3',
  manufactureYear: '2020',
  lastVerificationDate: '10.03.2021',
  nextVerificationDate: '10.03.2031',
  lastInspectionDate: '15.09.2026',
  lastReadingDate: '01.11.2026',
  activeEnergy: '12 458.32',
 });

 const openModal = () => setIsRequestOpen(true);
 const closeModal = () => setIsRequestOpen(false);
 const handleOpenJournal = () => setIsJournalOpen(true);
 const handleCloseJournal = () => setIsJournalOpen(false);

 const FormRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'baseline', py: 0.4, width: '100%' }}>
   <Box
    sx={{ flex: '0 0 35%', maxWidth: '480px', pr: 2, boxSizing: 'border-box' }}
   >
    <Typography
     sx={{
      fontSize: '0.875rem',
      fontWeight: 500,
      color: 'text.secondary',
      lineHeight: 1.2,
      wordBreak: 'keep-all',
     }}
    >
     {label}
    </Typography>
   </Box>
   <Box sx={{ flexGrow: 1, minWidth: 0 }}>
    <Typography
     sx={{
      fontSize: '0.875rem',
      fontWeight: 400,
      color: 'text.primary',
      lineHeight: 1.2,
      wordBreak: 'break-word',
     }}
    >
     {value || '—'}
    </Typography>
   </Box>
  </Box>
 );

 const openDialog = useSelector(
  (state: RootState) =>
   state.openDialogMeteringDeviceAdditional ??
   state.openDialogMeteringDeviceAdditional,
  shallowEqual,
 );

 const closeDialogHandler = (e: React.MouseEvent) => {
  e.stopPropagation();
  dispatch(openDialogMeteringDeviceAdditional(false));
 };

 return (
  <div>
   <Dialog
    className={classes.dialogContainer}
    open={Boolean(openDialog)}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
    PaperProps={{
     sx: {
      width: '100%',
      maxWidth: '1200px',
      height: '750px',
      overflow: 'hidden',
      marginTop: '20px',
     },
    }}
   >
    <DialogTitle
     className={classes.dialogTitle}
     style={{
      cursor: 'move',
      backgroundColor: 'black',
      border: '1px black solid',
     }}
     id="draggable-dialog-title"
    >
     <Box
      sx={{
       display: 'flex',
       justifyContent: 'space-between',
       alignItems: 'center',
       width: '100%',
       height: '40px',
      }}
     >
      <Typography
       sx={{
        fontWeight: 'bold',
        color: 'white',
        fontSize: '16px',
        fontFamily: 'calibri',
        lineHeight: 1,
       }}
      >
       Информация о приборе учета
      </Typography>

      {/* Кнопка закрытия смещена вправо суммарно на 10px */}
      <Box
       onClick={closeDialogHandler}
       sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        p: 0.5,
        zIndex: 10,
        marginRight: '-10px', // <--- Сдвинули еще на 5px вправо (итого -10px)
       }}
      >
       <CloseIcon
        style={{ fontSize: '20px', fontWeight: 800, color: 'white' }}
       />
      </Box>
     </Box>
    </DialogTitle>

    <DialogContent
     className={classes.dialog}
     sx={{
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100% - 40px)',
      overflow: 'hidden',
     }}
    >
     <Box
      sx={{
       px: 3,
       pt: '80px',
       pb: 1.5,
       overflowY: 'auto',
       flexGrow: 1,
       width: '100%',
       boxSizing: 'border-box',
      }}
     >
      <FormRow label="Адрес" value={data.address} />
      <FormRow label="Тип строения" value={data.buildingType} />
      <FormRow label="Тип помещения" value={data.roomType} />
      <FormRow
       label="Уникальный идентификатор точки поставки"
       value={data.deliveryPointId}
      />
      <FormRow label="Состояние реле" value={data.relayStatus} />
      <Divider sx={{ my: 0.6, opacity: 0.6 }} />

      <Typography
       sx={{
        fontSize: '0.8rem',
        fontWeight: 'bold',
        color: 'primary.main',
        mb: 0.3,
        mt: 0.3,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
       }}
      >
       Характеристики прибора учета
      </Typography>
      <FormRow label="Тип ПУ" value={data.meterType} />
      <FormRow
       label="Дата ввода в эксплуатацию"
       value={data.commissioningDate}
      />
      <FormRow label="Место установки" value={data.installationPlace} />
      <FormRow label="Заводской номер" value={data.serialNumber} />
      <FormRow label="Единицы измерения" value={data.unit} />
      <FormRow label="Класс точности" value={data.accuracyClass} />
      <FormRow label="Разрядность" value={data.capacity} />
      <FormRow label="Число фаз" value={data.phaseCount} />
      <FormRow label="Год выпуска" value={data.manufactureYear} />
      <Divider sx={{ my: 0.6, opacity: 0.6 }} />

      <Typography
       sx={{
        fontSize: '0.8rem',
        fontWeight: 'bold',
        color: 'primary.main',
        mb: 0.3,
        mt: 0.3,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
       }}
      >
       Поверка
      </Typography>
      <FormRow
       label="Дата последней поверки"
       value={data.lastVerificationDate}
      />
      <FormRow
       label="Дата следующей поверки"
       value={data.nextVerificationDate}
      />
      <FormRow label="Дата последнего обхода" value={data.lastInspectionDate} />
      <FormRow
       label="Дата последнего снятия результатов измерений с ПУ"
       value={data.lastReadingDate}
      />
      <Divider sx={{ my: 1.2, opacity: 0.6 }} />

      <Box sx={{ mt: '20px', mb: 1 }}>
       <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        sx={{ mb: 1.5, flexWrap: 'wrap' }}
       >
        <Typography
         sx={{
          fontSize: '0.8rem',
          fontWeight: 'bold',
          color: 'primary.main',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
         }}
        >
         Показания ПУ на ({currentDateTime})
        </Typography>
        <Button
         variant="outlined"
         color="primary"
         size="small"
         onClick={openModal}
        >
         Опросить
        </Button>
        <Button
         variant="outlined"
         color="primary"
         size="small"
         //onClick={openModal}
         sx={{ marginLeft: '10px !important' }}
        >
         Обновить
        </Button>
       </Stack>

       <FormRow
        label="Суммарная активная энергия, КВтч"
        value={data.activeEnergy}
       />
      </Box>
     </Box>

     <Box
      sx={{
       p: 2,
       px: 3,
       borderTop: '1px solid',
       borderColor: 'divider',
       bg: 'background.paper',
       flexShrink: 0,
      }}
     >
      <Stack direction="row" justifyContent="flex-start">
       <Button
        variant="outlined"
        color="primary"
        size="medium"
        sx={{ borderRadius: '20px' }}
        onClick={handleOpenJournal}
       >
        Журнал ПУ
       </Button>
      </Stack>
     </Box>
    </DialogContent>
   </Dialog>

   <DialogMeteringDeviceAdditionalRequest
    isOpen={isRequestOpen}
    onClose={closeModal}
   />

   <DialogMeteringDeviceAdditionalJournal
    open={isJournalOpen}
    handleClose={handleCloseJournal}
   />
  </div>
 );
};

export default memo(DialogMeteringDeviceAdditional);
